import { Box, makeStyles } from '@material-ui/core';
import React, { memo, useEffect, useRef } from 'react';
import { usePartnersData } from '../../store/modules/services/searchPartnersApi/hooks';
import PartnerCardMobile from './PartnerCardMobile';
import { FixedSizeList as List } from 'react-window';
import useWindowDimensions from 'global/react/hooks/useWindowDimensions';
import { useSelector } from 'react-redux';
import { focussedPartnerIdSelector } from '../../store/modules/fhw/selectors';
import { PartnerEntity } from '../../model/partner';

const Column = ({ index, style, data }: { index: number, style: any, data: PartnerEntity }) => {
	if (!data[index].id) return null;
	return (
		<div style={style} key={data[index].id}>
			<PartnerCardMobile partner={data[index]} />
		</div>
	);
};

const PartnerListMobile = (): JSX.Element | null => {
	const data = usePartnersData();
	const focussedPartnerId = useSelector(focussedPartnerIdSelector);

	const internalClasses = useStyles();
	const listRef = useRef<any>()
	const { width } = useWindowDimensions()

	useEffect(() => {
		if (listRef.current && listRef.current.state.scrollOffset !== 0) {
			listRef.current.scrollToItem({ columnIndex: 0 })
		}
	}, [data])

	useEffect(() => {
		if (focussedPartnerId && listRef.current && listRef.current.state.scrollOffset !== 0) {
			const partnerColumnIndex = data.partners.findIndex((item) => item.id === focussedPartnerId);
			listRef.current.scrollToItem({ columnIndex: partnerColumnIndex });
		}
	}, [data, focussedPartnerId]);

	return data?.partners ? (
		<Box className={internalClasses?.resultsWrapper}>
			<List
				ref={listRef}
				className="List"
				height={213}
				itemCount={data.count}
				itemSize={(width > 959) ? 360 : 340}
				width={width}
				layout="horizontal"
				itemData={data.partners}>
				{Column}
			</List>
		</Box>
	) : null;
};

export default memo(PartnerListMobile);

const useStyles = makeStyles((theme) => ({
	resultsWrapper: {
		position: 'absolute',
		maxWidth: '100vw',
		bottom: 0,
		left: 0,
		right: 0,
		paddingBottom: '0',
		display: 'flex',
		flexWrap: 'nowrap',
		overflowX: 'auto',
		overflowY: 'hidden',
		backgroundColor: 'transparent',
		[theme.breakpoints.up('lg')]: {
			display: 'none',
		},
	},
}));
